import { CallerTeamsState } from '../api/types';

/**
 * Whether the caller can quiesce/lift a finding owned by `rowTeam`.
 * `callerTeams === null` means `/whoami` hasn't resolved yet (or failed
 * transiently) — fail open and let the existing 403-on-submit flow be the
 * real gate. `callerTeams === 'unconfigured'` means the backend has no
 * shared secret set up yet, so the action can never succeed — hide it.
 */
export function canManageQuiesce(
  rowTeam: string | undefined,
  callerTeams: CallerTeamsState,
): boolean {
  if (callerTeams === 'unconfigured') return false;
  if (callerTeams === null) return true;
  if (!rowTeam) return true;
  return callerTeams.includes(rowTeam);
}
